import { Title, Alert } from '@mantine/core';
import { ProjectCard } from './ProjectCard';
import { useDatabaseLock } from '../../core/database-lock/DatabaseLockProvider';

export const ProjectCardCreate = () => {
  const { loading, canModify } = useDatabaseLock();

  if (loading) return null;

  if (!canModify) {
    return (
      <>
        <Title c="#322886">Nový projekt</Title>
        <Alert color="red" mt="md">
          Databáze je momentálně uzamčená. Nelze vytvářet nové projekty.
        </Alert>
      </>
    );
  }

  return (
    <>
      <Title c="#322886">Nový projekt</Title>
      <ProjectCard />
    </>
  );
};
